module.exports = __webpack_public_path__ + "img/FDUSD-icon.85313691.svg";